import { ManagementScheduleRepository } from '@domain/management-schedule/repositories/management-schedule.repository';
import { ManagementScheduleRepositoryService } from '../repositories/management-schedule.service';

export const ManagementScheduleProvider = [
  {
    provide: ManagementScheduleRepository,
    useClass: ManagementScheduleRepositoryService,
  },
];
